import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { baseUrl } from '../../../../config/route-entry-point';

import map from 'lodash/map';
import range from 'lodash/range';
import reverse from 'lodash/reverse';

import classname from 'classname';
import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select';
import AvatarField from './file-field';
import TimezonesMap from '../timezones-map/main';
import getFullSizeDefaultAva from '../../../../apps/everad/assets/img/global/default-avatars/web_300x300.png';

lessRequire('modules/profile/components/forms/personal-data.less');

const isEverad = process.env.CPA_ENV === 'everad';

const Form = props => {
	const {
		languages,
		timezones,
		handleSubmit,
		initialValues,
		deleteAvatar,
		addFileToUpload,
		updatePersonal,
		uploadError,
		intl
	} = props;

	const languageOptions = map(languages, lang => {
		return {
			label: (
				<span
					className={classname({
						'flag-icon': true,
						'flag-icon-ru': lang.id === 'ru',
						'flag-icon-ua': lang.id === 'uk',
						'flag-icon-gb': lang.id === 'en',
						'flag-icon-de': lang.id === 'de',
						'flag-icon-vn': lang.id === 'vi',
						'flag-icon-th': lang.id === 'th'
					})}
				>
					<span className="margin">
						{lang.text}
					</span>
				</span>
			),
			value: lang.id
		};
	});

	const dayOptions = range(1, 32).map(day => ({
		value: day > 9 ? `${day}` : `0${day}`,
		label: day > 9 ? `${day}` : `0${day}`
	}));

	const monthOptions = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	].map((month, i) => ({ value: i + 1 > 9 ? `${i + 1}` : `0${i + 1}`, label: intl(month) }));

	const yearOptions = reverse(range(1900, 2013)).map(year => ({ value: year, label: year }));

	const { additional_birthdays } = initialValues;

	return (
		<form
			action="#"
			className="profile__personal-data clearfix"
			onSubmit={handleSubmit(formData => updatePersonal(formData, initialValues))}
		>
			<div className="clearfix">
				<div className="profile-wrap__position-left">
					<div className="profile__personal-data__avatar">
						<div
							className="profile__personal-data__avatar-wrap"
							style={{
								background: `url('${initialValues.avatar || getFullSizeDefaultAva}') #fff 70% 70% / cover no-repeat`
							}}>
						</div>
						<div className="profile__personal-data__avatar-control">
							<Field
								name="avatar"
								component={AvatarField}
								placeholder={intl('Загрузить')}
								addFileToUpload={addFileToUpload}
							/>
							<a
								href="#"
								className="delete"
								onClick={e => {
									e.preventDefault();
									deleteAvatar();
								}}
							>
								{intl('Удалить')}
							</a>
						</div>
						{uploadError &&
						<div className="uploadError">
							{intl('Размер файла')}
							{intl('превышает лимит в 5МБ')}
						</div>}
					</div>
				</div>

				<div className="profile-wrap__position-left profile__personal-data-fields">
					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field name="language" placeholder={intl('Язык')} component={SelectField} options={languageOptions} />
						</div>
						<div className="profile-wrap__position-left" />
					</div>

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field
								name="nickname"
								placeholder={intl('Nickname')}
								component={InputField}
							/>
						</div>
					</div>

					{
						isEverad &&
						<div className="profile-wrap__form-field clearfix">
							<div className="profile-wrap__position-left">
								<Field
									name="promo_code"
									placeholder={intl('Промо код')}
									component={InputField}
									shouldDisable={!!initialValues['promo_code']}
								/>
							</div>
						</div>
					}

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field
								name="phone"
								placeholder={intl('Телефон')}
								component={InputField}
								shouldDisable={!!initialValues['phone']}
							/>
						</div>
						<div className="profile-wrap__position-left">
							{!!initialValues['phone'] &&
							<i className="profile-wrap__change-info font-times-new-roman-italic">
								{intl('Изменение номера телефона возможно только по запросу в')}&nbsp;
								<a href={baseUrl('tickets/request/change-phone/')}>{intl('службу поддержки')}</a>.
							</i>}
						</div>
					</div>

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field
								name="email"
								placeholder={intl('Email')}
								component={InputField}
								shouldDisable={!!initialValues['email']}
							/>
						</div>

						<div className="profile-wrap__position-left">
							<i className="profile-wrap__change-info font-times-new-roman-italic">
								{intl('Изменение электронной почты возможно только по запросу в')}&nbsp;
								<a href={baseUrl('tickets/request/change-email/')}>{intl('службу поддержки')}</a>.
							</i>
						</div>
					</div>

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field
								name="telegram"
								placeholder={intl('Telegram')}
								component={InputField}
								shouldDisable={!!initialValues['telegram']}
							/>
						</div>

						<div className="profile-wrap__position-left">
							{!!initialValues['telegram'] &&
							<i className="profile-wrap__change-info font-times-new-roman-italic">
								{intl('Изменение ника Telegram возможно только по запросу в')}&nbsp;
								<a href={baseUrl('tickets/request/change-telegram/')}>{intl('службу поддержки')}</a>.
							</i>}
						</div>
					</div>

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<div className="select-timezone" onClick={ () => props.toggleModalTimezone() }>
								<Field
									name="timezone"
									placeholder={intl('Часовой пояс')}
									component={SelectField}
									shouldDisable={true}
									options={timezones} />

								{ props.showModalTimezone && <TimezonesMap {...props} /> }
							</div>
						</div>
					</div>

					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left">
							<Field
								name="city"
								placeholder={intl('Город')}
								component={SelectField}
								shouldDisable={initialValues.city && !initialValues.can_change_city}
								searchable
								loadOptions={props.lookupCities}
							/>
						</div>

						{initialValues.city && (
							<div className="profile-wrap__position-left">
								{initialValues.can_change_city ? (
									<i className="profile-wrap__change-info font-times-new-roman-italic">
										Измените город, если он выбран неверно
									</i>
								) : (
									<i className="profile-wrap__change-info font-times-new-roman-italic">
										{intl('Изменение города возможно только по запросу в')}&nbsp;
										<a href={baseUrl('tickets/request/change-city/')}>{intl('службу поддержки')}</a>.
									</i>
								)}
							</div>
						)}
					</div>
					<div className="profile-wrap__form-field clearfix">
						<div className="profile-wrap__position-left birthday-fields">
							<label className="birthday-label">
								{intl('День рождения')}
							</label>
							<Field
								name="birthday_day"
								className="day"
								placeholder={intl('День')}
								component={SelectField}
								shouldDisable={!!initialValues['birthday']}
								options={dayOptions}
							/>
							<Field
								name="birthday_month"
								className="month"
								placeholder={intl('Месяц')}
								component={SelectField}
								shouldDisable={!!initialValues['birthday']}
								options={monthOptions}
							/>
							<Field
								name="birthday_year"
								className="year"
								placeholder={intl('Год')}
								component={SelectField}
								shouldDisable={!!initialValues['birthday']}
								options={yearOptions}
							/>
						</div>

						<div className="profile-wrap__position-left profile-wrap__change-info-wrapper">
							{!!initialValues['birthday'] &&
							<i className="profile-wrap__change-info font-times-new-roman-italic">
								{intl('Изменение даты рождения возможно только по запросу в')}&nbsp;
								<a href={baseUrl('tickets/request/change-birthday/')}>{intl('службу поддержки')}</a>.
							</i>}
						</div>
					</div>
					{
						additional_birthdays && !!additional_birthdays.length &&
						additional_birthdays.map((ab, index) =>
							<div className="profile-wrap__form-field clearfix" key={index}>
								<div className="profile-wrap__position-left birthday-fields">
									<label className="birthday-label">
										{intl('День рождения')}
									</label>
									<Field
										name="additional_birthday_day"
										className="day"
										placeholder={intl('День')}
										component={InputField}
										shouldDisable={true}
										input={{ value: ab.birthday_day }}
									/>
									<Field
										name="additional_birthday_month"
										className="month active"
										input={{ value: ab.birthday_month }}
										placeholder={intl('Месяц')}
										component={InputField}
										shouldDisable={true}
									/>
									<Field
										name="additional_birthday_year"
										className="year active"
										input={{ value: ab.birthday_year }}
										placeholder={intl('Год')}
										component={InputField}
										shouldDisable={true}
									/>
								</div>

								<div className="profile-wrap__position-left profile-wrap__change-info-wrapper">
									<i className="profile-wrap__change-info font-times-new-roman-italic">
										{intl('Изменение даты рождения возможно только по запросу в')}&nbsp;
										<a href={baseUrl('tickets/request/change-birthday/')}>
											{intl('службу поддержки')}
										</a>.
									</i>
								</div>
							</div>
						)
					}
				</div>
			</div>

			<button className="button yellow-btn profile-change-btn font-proxima-nova-semibold">
				{intl('Изменить данные')}
			</button>
		</form>
	);
};

Form.propTypes = {
	languages: PropTypes.array,
	timezones: PropTypes.array,
	initialValues: PropTypes.object,
	deleteAvatar: PropTypes.func,
	addFileToUpload: PropTypes.func,
	handleSubmit: PropTypes.func,
	updatePersonal: PropTypes.func,
	uploadError: PropTypes.bool,
	showModalTimezone: PropTypes.bool,
	toggleModalTimezone: PropTypes.func,
	lookupCities: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'profilePersonalDataForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/personal-data.js